// Country mappings for address parsing
export const COUNTRY_MAPPINGS = {
  'Canada': 'CAN',
  'United States': 'USA',
  'United States of America': 'USA',
  'US': 'USA',
  'CA': 'CAN',
  'UK': 'GBR',
  'United Kingdom': 'GBR',
  'France': 'FRA',
  'Germany': 'DEU',
  'Spain': 'ESP',
  'Italy': 'ITA',
  'Netherlands': 'NLD',
  'Belgium': 'BEL',
  'Austria': 'AUT',
  'Switzerland': 'CHE',
  'Portugal': 'PRT'
};

// Common city name mappings for variations
export const CITY_MAPPINGS = {
  'Montreal': 'Montreal',
  'Montréal': 'Montreal', 
  'Toronto': 'Toronto',
  'Vancouver': 'Vancouver',
  'Calgary': 'Calgary',
  'Edmonton': 'Edmonton',
  'Ottawa': 'Ottawa',
  'Quebec City': 'Quebec City',
  'Winnipeg': 'Winnipeg',
  'Hamilton': 'Hamilton',
  'New York': 'New York',
  'Los Angeles': 'Los Angeles',
  'Chicago': 'Chicago',
  'Houston': 'Houston',
  'Phoenix': 'Phoenix',
  'Philadelphia': 'Philadelphia',
  'San Antonio': 'San Antonio',
  'San Diego': 'San Diego',
  'Dallas': 'Dallas',
  'San Jose': 'San Jose'
};